import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { tap, delay, catchError } from 'rxjs/operators';
import { AppConfig } from '../app.config';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Configuration } from '../app.constants';
import * as _ from 'lodash';
import { AuthService } from './auth.service';
import { Language, LanguageAdapter } from '../core/language.model';
import { map } from 'rxjs/operators';
import { OnScreenMessageService } from './onScreenMessage/onScreenMessage.sevice';
import { Country, CountryAdapter } from '../core/country.model';
import { TranslateService } from '@ngx-translate/core';


@Injectable({
    providedIn: 'root'
})
export class CommonService {
    constructor(private translate: TranslateService, private onScreenMessageService: OnScreenMessageService, private countryAdapter: CountryAdapter, private langAdapter: LanguageAdapter, private http: HttpClient, private authService: AuthService, private appConfig: AppConfig, private appPrivate: AppConfig) { }

    getcountry(): Observable<Country[]> {
        let headers = this.getJwtToken();
        return this.http.get(`${this.appConfig.getAppConfig().authUrl}/country`, { headers }).pipe(
            map((data: Country[]) => data.map(item => this.countryAdapter.adapt(item)))
        )
    }

    getLabels(langId: string, moduleType: string): Observable<any> {
        if ("en_US" === langId)
            return this.http.get("./assets/showcase/data/label_en_" + moduleType + ".json")
        if ("fr_FR" === langId)
            return this.http.get("./assets/showcase/data/label_fr_" + moduleType + ".json")
        if ("hu_HU" === langId)
            return this.http.get("./assets/showcase/data/label_hu_" + moduleType + ".json")
    }

    getLanguage(): Observable<Language[]> {
        let headers = this.getJwtToken();
        return this.http.get(`${this.appConfig.getAppConfig().authUrl}/languages`, { headers }).pipe(
            //adapt each item in the raw data array
            map((data: Language[]) => data.map(item => this.langAdapter.adapt(item)))
        )
    }

    getConsents(): Observable<any> {
        return this.http.get("./assets/showcase/data/consents/consents.json");
    }


    formatDate(date: string): string {
        if (date == "" || date == undefined)
            return ''
        return `${date.slice(0, 4) + '/' + date.slice(4)}`
    }

    getUIModuleName(): any[] {
        let vehicles = [
            { label: 'General', value: '1' },
            { label: 'Error', value: '2' }
        ]
        return vehicles
    }

    getRefVehicleType(): any[] {
        let vehicle = [
            { label: 'Personal', value: 'pv' },
            { label: 'Commercial', value: 'cv' }]
        return vehicle
    }

    getJwtToken(): HttpHeaders {

        let token = localStorage.getItem('token');
        return new HttpHeaders({ 'Authorization': `Bearer ${token}` });
    }


    handlerError(error) {
        if (error.error.status == 'Unauthorized') {
            localStorage.setItem('isAutenticatedUser', 'false');
            this.translate.get('SCV.LOG.MSGSESSIONTIMEOUT').subscribe((value) => {
                this.onScreenMessageService.Error(this.translate.instant(value));
                return false;
            });
        } else this.onScreenMessageService.Error(error.error.message)
    }



}